// @ts-nocheck

export const ApplicationTypes: StringEnum = {
  SITE: 'winamax',
  MOBILE_POKER: 'mobile-poker',
  MOBILE_BETTING: 'mobile-betting',
  DESKTOP: 'desktop',
};

/** Les types de platformes. */
export const ApplicationPlatforms: StringEnum = {
  IOS: 'ios',
  ANDROID: 'android',
  WINDOWS: 'win',
  MACOS: 'mac',
  LINUX: 'linux',
  WEB: 'web',
};
